// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__DSYtV","stickyLabel":"styles_stickyLabel__1b43x","small":"styles_small__1Ylj2","extra-small":"styles_extra-small__1u4_a","isSticky":"styles_isSticky__39w3y"};